<template>
  <div class="container">
    <div class="top-bar">
      <tabBar
        class="tab"
        :tabList="VideoListObj.tabList"
        :activeID.sync="activeID"
        v-if="!search.searching"
      ></tabBar>
      <div
        class="search"
        :class="{ active: search.searching }"
        @click="search.searching = true"
      >
        <i class="icon icon-search"></i>
        <input
          v-model.lazy="search.keyWord"
          type=""
          name=""
          :placeholder="getDict(16)"
          :disabled="!search.searching"
        />
        <div class="hover" v-if="!search.searching"></div>
      </div>
      <div
        class="cancel-btn"
        v-if="search.searching"
        @click="search.searching = false"
      >
        {{ getDict(22) }}
      </div>
      <!-- <template>
        
      </template>
      <template v-if="search.searching">
        
      </template> -->
    </div>
    <div class="bottom-box">
      <div class="video-box">
        <div class="left-banner" v-if="bannerList.length && !search.searching">
          <imgPlayer
            @clickImg="clickBanner"
            class="img-box"
            :imgList="
              bannerList.map((obj) => {
                return obj.img;
              })
            "
            ref="bannerPlayer"
            v-model="bannerIndex"
          ></imgPlayer>
          <!-- <div class="img-box">
            <img v-for="(banner,index) in bannerList" :src="banner.img">
          </div> -->
          <div class="img-select">
            <div
              class="btn"
              :class="{ active: bannerIndex == index - 1 }"
              v-for="index in bannerList.length"
              :key="index"
            ></div>
            <!-- <div class="btn"></div>
            <div class="btn"></div> -->
          </div>
        </div>
        <div class="right-list">
          <div class="list-line" v-if="!search.searching">
            <div class="top">
              <div
                v-for="(item, index) in videoList"
                class="video-tab"
                :class="activeVideoTabIndex == index ? 'active' : ''"
                @click="switchVideoTab(index)"
                :key="index"
              >
                {{ item.name }}
              </div>
            </div>
            <div class="search-list" v-if="videoList[activeVideoTabIndex]">
              <div
                class="search-video-item-box item3"
                v-for="v in videoList[activeVideoTabIndex].videos"
                :key="v.videoId"
              >
                <div class="search-video-item">
                  <div class="video-container" @click="goVideo(v.videoId)">
                    <div
                      class="video-thumbnail-wrapper"
                      :style="{ backgroundImage: `url(${v.thumbnailMedium})` }"
                    >
                      <div class="size"></div>
                      <div class="video-info">
                        <div class="user-info">
                          <span
                            class="user-avatar"
                            :style="{
                              backgroundImage: `url(${v.streamerAvatar})`,
                            }"
                          ></span
                          ><span class="user-name">{{ v.streamer }}</span>
                        </div>
                        <div class="watch-num">
                          <i class="icon icon-video-watch-people"></i
                          >{{ v.viewCount | readableNum }}
                        </div>
                      </div>
                    </div>
                    <h3 class="video-title">{{ v.title }}</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="search-list"
            v-if="search.searching"
            @scroll="scrollList($event)"
          >
            <div
              class="search-video-item-box item4"
              v-for="v in VideoListObj.searchList"
              :key="v.videoId"
            >
              <div class="search-video-item">
                <div class="video-container" @click="goVideo(v.videoId)">
                  <div
                    class="video-thumbnail-wrapper"
                    :style="{ backgroundImage: `url(${v.thumbnailMedium})` }"
                  >
                    <div class="size"></div>
                    <div class="video-info">
                      <div class="user-info">
                        <span
                          class="user-avatar"
                          :style="{
                            backgroundImage: `url(${v.streamerAvatar})`,
                          }"
                        ></span
                        ><span class="user-name">{{ v.streamer }}</span>
                      </div>
                      <div class="watch-num">
                        <i class="icon icon-video-watch-people"></i
                        >{{ v.viewCount | readableNum }}
                      </div>
                    </div>
                  </div>
                  <h3 class="video-title">{{ v.title }}</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDict, getPageLevelMixin } from "../../common";

import TabBar from "../../components/tabBar";
import ScrollBox from "../../components/scrollBox";
import ImgPlayer from "../../components/imgPlayer";
import { mapState, mapGetters } from "vuex";
import { axios } from "@/common";
import store from "@/store";

export default {
  name: "videoList",
  mixins: [getPageLevelMixin],
  props: {},
  data() {
    return {
      pageLevel: 1,
      activeID: "",
      /* bannerList:[{
          img:require('../imgs/banner-pic.png'),
        },{
          img:require('../imgs/banner-pic0.png'),
        },{
          img:require('../imgs/banner-pic1.png'),
        },{
          img:require('../imgs/banner-pic2.png'),
        },],*/
      search: {
        searching: false,
        keyWord: "",
        last: 0,
      },
      bannerIndex: 0,
      activeVideoTabIndex: 0,
      /* videoList:[{
          name:'荒野之光',
          list:[{
            title: '直播直播直播名称直播直播直播名称直播直播直播名称',
            watchNum: 115000,
            type: 'video',
            user: '無雙無雙無雙無雙無雙無雙~',
            userAvatar: 'https://brandmark.io/logo-rank/random/mcdonalds.png',
            followed: false,
            platform: 'youtube',
            id: 'M7lc1UVf-VE',
            thumbnail: 'https://brandmark.io/logo-rank/random/apple.png',
          },{
            title: '直播直播直播名称直播直播直播名称直播直播直播名称',
            watchNum: 115000,
            type: 'video',
            user: '無雙無雙無雙無雙無雙無雙~',
            userAvatar: 'https://brandmark.io/logo-rank/random/mcdonalds.png',
            followed: false,
            platform: 'youtube',
            id: 'M7lc1UVf-VE',
            thumbnail: 'https://brandmark.io/logo-rank/random/apple.png',
          },{
            title: '直播直播直播名称直播直播直播名称直播直播直播名称直播直播直播名称',
            watchNum: 115000,
            type: 'video',
            user: '無雙無雙無雙無雙無雙無雙~',
            userAvatar: 'https://brandmark.io/logo-rank/random/mcdonalds.png',
            followed: false,
            platform: 'youtube',
            id: 'M7lc1UVf-VE',
            thumbnail: 'https://brandmark.io/logo-rank/random/apple.png',
          },{
            title: '直播直播直播名称直播直播直播名称直播直播直播名称',
            watchNum: 115000,
            type: 'video',
            user: '無雙無雙無雙無雙無雙無雙~',
            userAvatar: 'https://brandmark.io/logo-rank/random/mcdonalds.png',
            followed: false,
            platform: 'youtube',
            id: 'M7lc1UVf-VE',
            thumbnail: 'https://brandmark.io/logo-rank/random/apple.png',
          },{
            title: '直播直播直播名称直播直播直播名称直播直播直播名称',
            watchNum: 115000,
            type: 'video',
            user: '無雙無雙無雙無雙無雙無雙~',
            userAvatar: 'https://brandmark.io/logo-rank/random/mcdonalds.png',
            followed: false,
            platform: 'youtube',
            id: 'M7lc1UVf-VE',
            thumbnail: 'https://brandmark.io/logo-rank/random/apple.png',
          },{
            title: '直播直播直播名称直播直播直播名称直播直播直播名称直播直播直播名称',
            watchNum: 115000,
            type: 'video',
            user: '無雙無雙無雙無雙無雙無雙~',
            userAvatar: 'https://brandmark.io/logo-rank/random/mcdonalds.png',
            followed: false,
            platform: 'youtube',
            id: 'M7lc1UVf-VE',
            thumbnail: 'https://brandmark.io/logo-rank/random/apple.png',
          },{
            title: '直播直播直播名称直播直播直播名称直播直播直播名称',
            watchNum: 115000,
            type: 'video',
            user: '無雙無雙無雙無雙無雙無雙~',
            userAvatar: 'https://brandmark.io/logo-rank/random/mcdonalds.png',
            followed: false,
            platform: 'youtube',
            id: 'M7lc1UVf-VE',
            thumbnail: 'https://brandmark.io/logo-rank/random/apple.png',
          },{
            title: '直播直播直播名称直播直播直播名称直播直播直播名称直播直播直播名称',
            watchNum: 115000,
            type: 'video',
            user: '無雙無雙無雙無雙無雙無雙~',
            userAvatar: 'https://brandmark.io/logo-rank/random/mcdonalds.png',
            followed: false,
            platform: 'youtube',
            id: 'M7lc1UVf-VE',
            thumbnail: 'https://brandmark.io/logo-rank/random/apple.png',
          }]
        },{
          name:'荒野之光',
          list:[{
            title: '直播直播直播名称直播直播直播名称直播直播直播名称',
            watchNum: 115000,
            type: 'video',
            user: '無雙無雙無雙無雙無雙無雙~',
            userAvatar: 'https://brandmark.io/logo-rank/random/mcdonalds.png',
            followed: false,
            platform: 'youtube',
            id: 'M7lc1UVf-VE',
            thumbnail: 'https://brandmark.io/logo-rank/random/apple.png',
          },{
            title: '直播直播直播名称直播直播直播名称直播直播直播名称',
            watchNum: 115000,
            type: 'video',
            user: '無雙無雙無雙無雙無雙無雙~',
            userAvatar: 'https://brandmark.io/logo-rank/random/mcdonalds.png',
            followed: false,
            platform: 'youtube',
            id: 'M7lc1UVf-VE',
            thumbnail: 'https://brandmark.io/logo-rank/random/apple.png',
          },{
            title: '直播直播直播名称直播直播直播名称直播直播直播名称直播直播直播名称',
            watchNum: 115000,
            type: 'video',
            user: '無雙無雙無雙無雙無雙無雙~',
            userAvatar: 'https://brandmark.io/logo-rank/random/mcdonalds.png',
            followed: false,
            platform: 'youtube',
            id: 'M7lc1UVf-VE',
            thumbnail: 'https://brandmark.io/logo-rank/random/apple.png',
          },{
            title: '直播直播直播名称直播直播直播名称直播直播直播名称',
            watchNum: 115000,
            type: 'video',
            user: '無雙無雙無雙無雙無雙無雙~',
            userAvatar: 'https://brandmark.io/logo-rank/random/mcdonalds.png',
            followed: false,
            platform: 'youtube',
            id: 'M7lc1UVf-VE',
            thumbnail: 'https://brandmark.io/logo-rank/random/apple.png',
          },{
            title: '直播直播直播名称直播直播直播名称直播直播直播名称直播直播直播名称',
            watchNum: 115000,
            type: 'video',
            user: '無雙無雙無雙無雙無雙無雙~',
            userAvatar: 'https://brandmark.io/logo-rank/random/mcdonalds.png',
            followed: false,
            platform: 'youtube',
            id: 'M7lc1UVf-VE',
            thumbnail: 'https://brandmark.io/logo-rank/random/apple.png',
          }]
        },{
          name:'荒野之光',
          list:[{
            title: '直播直播直播名称直播直播直播名称直播直播直播名称',
            watchNum: 115000,
            type: 'video',
            user: '無雙無雙無雙無雙無雙無雙~',
            userAvatar: 'https://brandmark.io/logo-rank/random/mcdonalds.png',
            followed: false,
            platform: 'youtube',
            id: 'M7lc1UVf-VE',
            thumbnail: 'https://brandmark.io/logo-rank/random/apple.png',
          },{
            title: '直播直播直播名称直播直播直播名称直播直播直播名称',
            watchNum: 115000,
            type: 'video',
            user: '無雙無雙無雙無雙無雙無雙~',
            userAvatar: 'https://brandmark.io/logo-rank/random/mcdonalds.png',
            followed: false,
            platform: 'youtube',
            id: 'M7lc1UVf-VE',
            thumbnail: 'https://brandmark.io/logo-rank/random/apple.png',
          },{
            title: '直播直播直播名称直播直播直播名称直播直播直播名称直播直播直播名称',
            watchNum: 115000,
            type: 'video',
            user: '無雙無雙無雙無雙無雙無雙~',
            userAvatar: 'https://brandmark.io/logo-rank/random/mcdonalds.png',
            followed: false,
            platform: 'youtube',
            id: 'M7lc1UVf-VE',
            thumbnail: 'https://brandmark.io/logo-rank/random/apple.png',
          },{
            title: '直播直播直播名称直播直播直播名称直播直播直播名称',
            watchNum: 115000,
            type: 'video',
            user: '無雙無雙無雙無雙無雙無雙~',
            userAvatar: 'https://brandmark.io/logo-rank/random/mcdonalds.png',
            followed: false,
            platform: 'youtube',
            id: 'M7lc1UVf-VE',
            thumbnail: 'https://brandmark.io/logo-rank/random/apple.png',
          },{
            title: '直播直播直播名称直播直播直播名称直播直播直播名称直播直播直播名称',
            watchNum: 115000,
            type: 'video',
            user: '無雙無雙無雙無雙無雙無雙~',
            userAvatar: 'https://brandmark.io/logo-rank/random/mcdonalds.png',
            followed: false,
            platform: 'youtube',
            id: 'M7lc1UVf-VE',
            thumbnail: 'https://brandmark.io/logo-rank/random/apple.png',
          }]
        }]*/
      showMoreBtn: [],
    };
  },
  computed: {
    ...mapState(["_videoListObj"]),
    ...mapGetters(["VideoListObj"]),
    bannerList() {
      // return [];
      if (this.VideoListObj.banners) {
        return this.VideoListObj.banners.map((banner) => {
          return {
            img: `/upload/banner/${banner.image}`,
            videoId: banner.videoId,
            jump: banner.jump,
          };
        });
      } else {
        return [];
      }
    },
    videoList() {
      if (this.VideoListObj.collections) {
        return this.VideoListObj.collections;
      } else {
        return [];
      }
    },
  },
  watch: {
    activeID() {
      store.dispatch("getVideoList", this.activeID);
    },
    "search.searching"() {
      console.log(this.search.searching);
      if (this.search.searching) {
        store.dispatch("searchVideo", "");
      } else {
        this.search.keyWord = "";
      }
    },
    "search.keyWord"() {
      if (this.search.searching) {
        store.dispatch("searchVideo", this.search.keyWord);
      }
    },
  },
  methods: {
    switchVideoTab(index) {
      this.activeVideoTabIndex = index;
    },
    updateShowMoreBtn(index) {
      // console.log(index,this.$refs.videoList[index].scrollMore)
      this.$set(
        this.showMoreBtn,
        index,
        this.$refs.videoList[index].scrollMore
      );
    },
    scrollList(event) {
      // console.log(event.target.scrollTop)
      if (
        event.target.scrollHeight - event.target.scrollTop <
        event.target.clientHeight * 1.3
      ) {
        // console.log(9999999)
        store.dispatch("searchMoreVideo", this.search.keyWord);
      }
    },
    getDict,
    getMovePx(listNum) {
      let scrollLeft = this.$refs.videoList[listNum].getScrollLeft();
      let width0 = this.$refs[`videoList${listNum}Item`][0].clientWidth;
      let width1 = this.$refs[`videoList${listNum}Item`][1].offsetLeft;
      let boxWidth = this.$refs.videoList[listNum].$el.clientWidth;
      let pixel = width1 - ((scrollLeft + boxWidth - width0) % width1);
      if (pixel == 0) {
        return width1;
      }
      return pixel;
    },
    clickBanner(index) {
      console.log(index);
      if (this.bannerList[index]) {
        if (this.bannerList[index].jump) {
          let url = this.bannerList[index].jump;
          url = /^https?:\/\//.test(url) ? url : "http://" + url;
          location.href = url;
        } else if (this.bannerList[index].videoId) {
          this.goVideo(this.bannerList[index].videoId);
        }
      }
    },
    goVideo(id) {
      this.$router.push(`/video/${id}`);
    },
    searchMoreVideo() {
      store.dispatch("searchMoreVideo", this.search.keyWord);
    },
    async showCollectionById(id) {
      let collection = this.videoList.find((item) => item.id == id);
      if (collection) {
        this.activeID = this.VideoListObj.tabID;
      } else {
        let result = await axios.get(`/api/videoTabListByCollectionId/${id}`);
        if (result.status == 200) {
          if (result.data) {
            let list = result.data;
            if (list.length) {
              console.log(list[0].id);
              this.activeID = list[0].id;
              await store.dispatch("getVideoList", this.activeID);
            }
          }
        }
      }
      for (let index = 0; index < this.videoList.length; index++) {
        if (this.videoList[index].id == id) {
          this.activeVideoTabIndex = index;
        }
      }
    },
  },
  components: {
    TabBar,
    ScrollBox,
    ImgPlayer,
  },
  created() {
    store.dispatch("getVideoTabList").then(() => {
      if (this.$route.params && this.$route.params.collectionId) {
        this.showCollectionById(this.$route.params.collectionId);
      } else {
        this.activeID = this.VideoListObj.tabID;
      }
    });
    // window.searchMoreVideo = this.searchMoreVideo;
  },
};
</script>

<style lang="scss" scoped>
.container {
  margin-top: 0.3rem;
  padding: 0 0.4rem;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;

  .top-bar {
    // height: 100%;
    height: 0.6rem;
    flex-shrink: 0;
    flex-grow: 0;
    display: flex;
    justify-content: space-between;
    // background-color: rgba(0,0,0,0.1);
    margin-bottom: 0.2rem;

    .tab {
      width: 5rem;
      height: 0.44rem;
    }
    $searchHeight: 0.44rem;
    .search {
      display: flex;
      align-items: center;
      width: 4rem;
      height: $searchHeight;
      // background-color: #000;
      background-color: rgba(255, 255, 255, 0.5);
      padding: 0 0.2rem;
      position: relative;

      $font-size: 0.23rem;
      .icon {
        height: $font-size;
        width: $font-size * 0.9;
      }
      input {
        flex: 1;
        height: 0.35rem;
        padding: 0;
        border: 0;
        font-size: $font-size;
        // color: #fff;
        color: #232324;
        background: none;
      }
      .hover {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
      }

      &.active {
        flex-grow: 1;
      }
    }

    .cancel-btn {
      $font-size: 0.23rem;
      font-size: $font-size;
      height: $searchHeight;
      display: flex;
      align-items: center;
      display: flex;
      align-items: center;
      // width: 0.6rem;
      margin-left: 0.15rem;
      justify-content: flex-end;
    }
  }
  .bottom-box {
    margin-bottom: 0.3rem;
    // flex:1;
    display: flex;
    flex-direction: column;
    // justify-content: center;
    .video-box {
      height: 5rem;
      display: flex;

      .left-banner {
        $width: 2.8rem;
        height: 100%;
        width: $width;
        // width:3rem;
        margin-right: 0.3rem;
        // background-color: rgba(0,0,0,0.1);
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .img-box {
          width: $width;
          height: $width * 5/3;
          overflow: hidden;
          display: flex;
          img {
            width: 100%;
            height: 100%;
          }
        }

        .img-select {
          $height: 0.18rem;
          height: $height;
          // background-color: rgba(0,0,0,0.1);
          display: flex;
          justify-content: center;
          .btn {
            height: 100%;
            width: $height * 1.8;
            border-radius: $height;
            background-color: rgba(0, 0, 0, 0.1);
            margin: 0 $height/2;

            &.active {
              background-color: rgba(237, 174, 7, 1);
            }
          }
        }
      }

      .right-list {
        min-width: 0;
        flex: 1;
        background-color: rgba(252, 252, 252, 0.4);
        background-image: url(./imgs/video-list-bg.png);
        background-size: auto 100%;
        background-position-x: right;
        background-repeat: no-repeat;
        overflow: auto;
        padding: 0.2rem;
        height: 100%;

        .list-line {
          // background-color: #0f0;
          height: 100%;
          width: 100%;
          display: flex;
          flex-direction: column;

          // background-color: rgba(0,0,0,0.4);
          .top {
            $font-size: 0.16rem;

            // background-color: rgba(0,0,0,0.4);
            // height: $height;
            display: flex;
            padding-bottom: 0.1rem;
            // justify-content: space-between;
            .video-tab {
              // box-sizing: content-box;
              display: inline-block;
              // height: $height;
              border: 0.01rem solid #000;
              padding: 0 0.1rem;
              margin: 0 0.06rem;
              border-radius: 0.05rem;
              font-size: $font-size;
              line-height: $font-size * 1.2;
              &.active {
                border-color: #f8d108;
                background-color: #f8d108;
              }
            }
          }

          .video-list {
            overflow: hidden;
            // width: 100%;
            // overflow: auto;
            // background-color: rgba(0,0,0,0.4);

            ul {
              display: flex;
              li {
                margin-left: 0.2rem;
                &:first-child {
                  margin-left: 0;
                }
              }
            }
          }
        }

        .search-list {
          width: 100%;
          height: 100%;
          overflow: auto;
          padding-right: 0.1rem;
          // display: flex;
          // flex-wrap:wrap;
          // justify-content: space-between;

          &::-webkit-scrollbar {
            /*滚动条整体样式*/
            width: 0.04rem; /*高宽分别对应横竖滚动条的尺寸*/
            height: 1px;
          }
          &::-webkit-scrollbar-thumb {
            /*滚动条里面小方块*/
            background: #e9a500;
          }
          &::-webkit-scrollbar-track {
            /*滚动条里面轨道*/
            background: #aaa;
          }

          .search-video-item-box {
            display: inline-block;
            padding-bottom: 0.2rem;

            &.item4 {
              width: 25%;

              &:nth-child(4n + 1):nth-last-child(-n + 4),
              &:nth-child(4n + 1):nth-last-child(-n + 4) ~ div {
                padding-bottom: 0rem;
              }
            }
            &.item3 {
              width: 33%;

              &:nth-child(3n + 1):nth-last-child(-n + 3),
              &:nth-child(3n + 1):nth-last-child(-n + 3) ~ div {
                padding-bottom: 0rem;
              }
            }

            .search-video-item {
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;

              .video-container {
                margin: auto;
              }
            }
          }
        }
      }

      .video-container {
        $width: 2.8rem;
        display: inline-block;
        // width: $width;
        width: 100%;
        padding: 0 0.1rem;
        .video-thumbnail-wrapper {
          div.size {
            // width: 2.8rem;
            // height: 1.42rem;
            width: 100%;
            background-color: #0f0;
            margin-bottom: (137/280) * 100%;
            display: inline-block;
          }

          background: rgba(255, 255, 255, 0.4) no-repeat center center;
          // background-size: cover;
          background-size: 100% auto;
          position: relative;
          // border: .03rem solid #ffd559;
          .video-info {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            font-size: 0.14rem;
            height: 0.28rem;
            background: rgba(0, 0, 0, 0.7);
            color: #ffd559;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 0.18rem;

            .watch-num {
              .icon {
                vertical-align: text-bottom;
              }
            }
          }
          .user-info {
            .user-avatar {
              display: inline-block;
              background: no-repeat center center;
              background-size: 100% 100%;
              width: 0.24rem;
              height: 0.24rem;
              border-radius: 50%;
              margin-right: 0.04rem;
              border: 0.01rem solid #ecbc5f;
              vertical-align: -0.04rem;
            }
            .user-name {
              display: inline-block;
              max-width: 1.2rem;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
          }
        }
        .video-title {
          color: #232324;
          font-size: 0.18rem;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          margin-top: 0.03rem;
          line-height: 0.24rem;
        }
      }
    }
  }
}
</style>
